module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_Elora_v1.bf7f4af8.jpg";